/** 공통 색상 팔레트 (Tailwind zinc/indigo 계열 hex) */
export const BRAND = {
  indigo: "#6366f1",
  green: "#22c55e",
  emerald: "#10b981",
  amber: "#f59e0b",
  red: "#ef4444",
  blue: "#60a5fa",
} as const;

/** 점수 구간별 hex 색 (75/60/45 경계, getScoreColorHex에서 사용) */
export const SCORE_COLORS = {
  strongBuy: BRAND.green, // >= 75
  buy: BRAND.indigo, // >= 60
  hold: BRAND.amber, // >= 45
  sell: BRAND.red, // < 45
} as const;

/** 종목 비교 시리즈 색 (최대 3개) */
export const COMPARE_COLORS = [BRAND.indigo, BRAND.emerald, BRAND.amber];

/** 차트 데이터 시리즈 색 (라벨 → hex) */
export const CHART_SERIES_COLORS: Record<string, string> = {
  // 재무 추이 (FinancialChart)
  매출액: BRAND.indigo,
  영업이익: BRAND.green,
  당기순이익: BRAND.blue,
  // 지표 추이 (RatioChart)
  "ROE(%)": BRAND.indigo,
  "영업이익률(%)": BRAND.green,
  "매출성장률(%)": BRAND.amber,
  "부채비율(%)": BRAND.red,
};
